import { Paper, Typography, Stack, Button } from '@mui/material';

const PreLoadInterceptor = ({ hasPreExistentFilters, onConfirm, onCancel }) => (
    <Paper
        sx={{
            p: 4,
            mt: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            margin: '0 auto',
            minWidth: { xs: '80%', sm: '600px' },
            maxWidth: '75%',
        }}
        elevation={4}
    >
        <Typography>
            {hasPreExistentFilters
                ? 'Your previous search, filters, flags, and sort have been restored but have not been applied. Review, update, or clear them before loading results.'
                : 'Enter search criteria and press Enter, apply filters, or select Load Results to load all unbilled items.'}
        </Typography>
        <Stack direction="row" gap={2} mt={2}>
            <Button variant="contained" color="primary" onClick={onConfirm}>
                Load Results
            </Button>
            {hasPreExistentFilters && (
                <Button variant="contained" color="secondary" onClick={onCancel}>
                    Clear filters and search
                </Button>
            )}
        </Stack>
    </Paper>
);

export default PreLoadInterceptor;
